import { StdListHeaderCell } from 'components/StdList';
import React from 'react';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';

interface Props extends WithAppStoreProps {
  text: string;
  field: string;
  sortCell?: boolean;
}

class SubmittalListHeaderCell extends React.Component<Props> {
  static defaultProps = {
    text: '',
    sortCell: false,
  };

  handleSortCellClick = (): void => {
    const { field, appState, actions } = this.props;
    const { submittalQuery } = appState;

    const sameFieldDirection =
      submittalQuery.sortDirection === 'ascending' ? 'descending' : 'ascending';

    const sortDirection =
      field === submittalQuery.sortField ? sameFieldDirection : 'descending';

    const nextSubmittalQuery = submittalQuery.merge({
      sortField: field,
      sortDirection,
    });

    actions.setSubmittalQuery(nextSubmittalQuery);
  };

  render(): React.ReactNode {
    const { field, text, sortCell, appState } = this.props;
    const { submittalQuery } = appState;

    return (
      <StdListHeaderCell
        field={field}
        text={text}
        sortCell={sortCell}
        sortColumn={submittalQuery.sortField === field}
        leftBorder
        sortDirection={submittalQuery.sortDirection}
        onSortCellClick={this.handleSortCellClick}
      />
    );
  }
}

export default withAppStore<Props>(SubmittalListHeaderCell);
